module.exports = __webpack_public_path__ + "img/T300.e2502dba.jpg";